import { useMemo, useState } from 'react';

import {
  Box,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from '@mui/material';

import dayjs from 'dayjs';

import styles from './DateTimeSelector.module.css';

interface IYearMenu {
  onSelect: (y: number) => void;
  minDate?: dayjs.Dayjs;
  maxDate?: dayjs.Dayjs;
  startDate?: Date;
}

export default function YearMenu({
  onSelect,
  minDate,
  maxDate,
  startDate,
}: IYearMenu) {
  const year = startDate?.getFullYear() ?? null;
  const handleChange = (event: SelectChangeEvent) => {
    const y = Number(event.target.value);
    onSelect?.(y);
  };

  const data = useMemo(() => {
    if (!minDate || !maxDate) return [];

    const minYear = minDate?.year();
    const maxYear = maxDate?.year();

    if (minYear && maxYear)
      return Array.from(
        { length: maxYear - minYear + 1 },
        (_, i) => String(maxYear - i), // DESC order
      );
  }, [minDate, maxDate]);

  return (
    <Box className={styles.yearMenuWrapper}>
      <Typography variant="body2" fontSize="0.75rem">
        Year
      </Typography>
      <FormControl size="small" className={styles.yearMenuFormControl}>
        <Select
          size="small"
          className={styles.yearMenuSelect}
          value={year?.toString()}
          onChange={handleChange}
        >
          {data.map((y) => (
            <MenuItem key={y} value={y} sx={{ fontSize: 12 }}>
              {y}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
